export class RequestModel {
    contactNumber: string;
    referedBy: string;
    userEmail: string;
}